import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import en from './locales/en.json';

// Detectar idioma guardado o usar el del navegador de forma directa
const savedLanguage = localStorage.getItem('language');
const browserLanguage = navigator.language.split('-')[0];
const defaultLanguage = savedLanguage || (browserLanguage === 'es' || browserLanguage === 'en' ? browserLanguage : 'es');

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: es
      },
      en: {
        translation: en
      }
    },
    lng: defaultLanguage,
    fallbackLng: 'es',

    // Separador de objetos anidados de tus JSON
    keySeparator: '.', 
    nsSeparator: false,
    returnObjects: true,

    interpolation: {
      escapeValue: false
    },
    react: {
      // Fuerza a React a esperar a que las traducciones estén ligadas antes de pintar
      useSuspense: false 
    }
  });

export default i18n;